var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('CountdownBackground'),_c('Countdown',{attrs:{"timeLeft":_vm.timeLeft,"initialTime":_vm.initialTime,"tip":_vm.currentTip}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }